export const checkIcon = {
    '> svg': {
        height: '14px',
        marginTop: '2px',
        width: '16px',
    },
    'marginLeft': '5px',
}
